import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9e962088"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-text"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " Product prioritization "), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " By default, our AI selects products for activation based on their past sales performance. However, using this feature, you can prioritize the activation of specific products, even if their sales are lower than others. To set a product as a priority for activation, simply search for it and toggle them on . ")], -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "content-total"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_6 = {
  key: 0,
  class: "content-details"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " Activated products description that is a bit longer ", -1));
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " Activated products description that is a bit longer ", -1));
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " Activated products description that is a bit longer ", -1));
const _hoisted_13 = {
  class: "content-list"
};
const _hoisted_14 = {
  class: "content-header"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-header-cell fluid"
}, "Product image & name", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-header-cell fluid"
}, "ASIN", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-header-cell status"
}, "Status", -1));
const _hoisted_18 = {
  key: 0,
  class: "content-header-cell status"
};
const _hoisted_19 = {
  class: "content-body"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "view-text"
}, "View inactive products", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "view-text"
}, "View boosted products", -1));
const _hoisted_22 = {
  key: 0,
  class: "empty-products"
};
const _hoisted_23 = {
  key: 1,
  class: "content-box box-active"
};
const _hoisted_24 = {
  class: "content-cell fluid"
};
const _hoisted_25 = {
  class: "product"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "product-name"
};
const _hoisted_28 = {
  key: 0,
  class: "relations-badge"
};
const _hoisted_29 = {
  class: "content-cell fluid"
};
const _hoisted_30 = {
  class: "asin"
};
const _hoisted_31 = {
  class: "content-cell status"
};
const _hoisted_32 = {
  class: "status-badge status-active"
};
const _hoisted_33 = {
  key: 2,
  class: "box-active-placeholder"
};
const _hoisted_34 = {
  key: 3,
  ref: "omnyAI",
  class: "omny-ai"
};
const _hoisted_35 = {
  class: "omny-ai-badge"
};
const _hoisted_36 = {
  key: 4,
  class: "boosted-area"
};
const _hoisted_37 = {
  class: "boosted-frame"
};
const _hoisted_38 = {
  class: "boosted-header"
};
const _hoisted_39 = {
  class: "boosted-number"
};
const _hoisted_40 = {
  class: "boosted-title"
};
const _hoisted_41 = {
  class: "content-box box-boosted"
};
const _hoisted_42 = {
  class: "content-cell fluid"
};
const _hoisted_43 = {
  class: "product"
};
const _hoisted_44 = ["src"];
const _hoisted_45 = {
  class: "product-name"
};
const _hoisted_46 = {
  key: 0,
  class: "relations-badge"
};
const _hoisted_47 = {
  class: "content-cell fluid"
};
const _hoisted_48 = {
  class: "asin"
};
const _hoisted_49 = {
  class: "content-cell status"
};
const _hoisted_50 = {
  class: "status-badge status-inactive"
};
const _hoisted_51 = {
  class: "content-cell status"
};
const _hoisted_52 = {
  class: "boosted-badge"
};
const _hoisted_53 = {
  key: 5,
  ref: "inactive",
  class: "content-box box-inactive"
};
const _hoisted_54 = {
  class: "content-cell fluid"
};
const _hoisted_55 = {
  class: "product"
};
const _hoisted_56 = ["src"];
const _hoisted_57 = {
  class: "product-name"
};
const _hoisted_58 = {
  key: 0,
  class: "relations-badge"
};
const _hoisted_59 = {
  class: "content-cell fluid"
};
const _hoisted_60 = {
  class: "asin"
};
const _hoisted_61 = {
  class: "content-cell status"
};
const _hoisted_62 = {
  class: "status-badge status-inactive"
};
const _hoisted_63 = {
  class: "content-cell status"
};
const _hoisted_64 = ["onClick"];
const _hoisted_65 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_input = _resolveComponent("app-input");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_loader = _resolveComponent("app-loader");
  const _component_app_card_custom = _resolveComponent("app-card-custom");
  return _openBlock(), _createBlock(_component_app_card_custom, {
    "no-padding": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_app_input, {
      modelValue: $data.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search = $event),
      v2: "",
      placeholder: "Search for products...",
      "prepend-icon": "search",
      "prepend-simple": ""
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString($options.filteredProducts.total.length), 1), _hoisted_5, _createTextVNode(" total ")]), $options.filteredProducts.total.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [$options.percents.active > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "details-box details-active",
      style: _normalizeStyle(`height: ${$options.percents.active}%`)
    }, [_createElementVNode("div", _hoisted_7, _toDisplayString($options.filteredProducts.active.length) + " Activated product" + _toDisplayString($options.filteredProducts.active.length > 1 ? 's' : ''), 1), _hoisted_8], 4)) : _createCommentVNode("", true), $options.percents.boosted > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "details-box details-boosted",
      style: _normalizeStyle(`height: ${$options.percents.boosted}%`)
    }, [_createElementVNode("div", _hoisted_9, _toDisplayString($options.filteredProducts.boosted.length) + " Boosted product" + _toDisplayString($options.filteredProducts.boosted.length > 1 ? 's' : ''), 1), _hoisted_10], 4)) : _createCommentVNode("", true), $options.percents.inactive > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "details-box details-inactive",
      style: _normalizeStyle(`height: ${$options.percents.inactive}%`)
    }, [_createElementVNode("div", _hoisted_11, _toDisplayString($options.filteredProducts.inactive.length) + " Inactive product" + _toDisplayString($options.filteredProducts.inactive.length > 1 ? 's' : ''), 1), _hoisted_12], 4)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _hoisted_16, _hoisted_17, $data.isSecondStatus ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Status")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [$data.isOmnyAiUnder && $options.filteredProducts.inactive.length > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "view-box inactive",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.onInactiveScroll && $options.onInactiveScroll(...args))
    }, [_createVNode(_component_app_icon, {
      icon: "inactive",
      size: 16,
      color: "#fff"
    }), _hoisted_20, _createVNode(_component_app_icon, {
      icon: "arrow-down2"
    })])) : _createCommentVNode("", true), $data.isInactiveAbove && $options.filteredProducts.boosted.length > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "view-box boosted",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.onBoostedScroll && $options.onBoostedScroll(...args))
    }, [_createVNode(_component_app_icon, {
      icon: "active",
      size: 16,
      color: "#fff"
    }), _hoisted_21, _createVNode(_component_app_icon, {
      icon: "arrow-up2"
    })])) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "content-scroll",
      ref: "scroll",
      onScroll: _cache[3] || (_cache[3] = (...args) => $options.onScroll && $options.onScroll(...args))
    }, [$options.filteredProducts.total.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, " There are no products ")) : _createCommentVNode("", true), $options.filteredProducts.active.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredProducts.active, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.asin,
        class: "content-row"
      }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [item?.image && item.image != '' ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: item.image,
        alt: ""
      }, null, 8, _hoisted_26)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, _toDisplayString(item.name), 1)]), item?.relations && item.relations > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_app_icon, {
        icon: "relations"
      }), _createTextVNode(" " + _toDisplayString(item.relations), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(item.asin) + " - " + _toDisplayString(item.sku), 1)]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_app_icon, {
        icon: "active"
      }), _createTextVNode(" Active ")])])]);
    }), 128))])) : _createCommentVNode("", true), $options.filteredProducts.active.length == 0 && ($options.filteredProducts.boosted.length > 0 || $options.filteredProducts.inactive.length > 0) ? (_openBlock(), _createElementBlock("div", _hoisted_33)) : _createCommentVNode("", true), $options.filteredProducts.boosted.length > 0 || $options.filteredProducts.inactive.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_app_icon, {
      icon: "ai",
      size: 16,
      color: "#fff"
    }), _createTextVNode(" Omny AI ")])], 512)) : _createCommentVNode("", true), $options.filteredProducts.boosted.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString($options.filteredProducts.boosted.length), 1), _createElementVNode("div", _hoisted_40, "Boosted product" + _toDisplayString($options.filteredProducts.boosted.length > 1 ? 's' : ''), 1)]), _createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredProducts.boosted, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.asin,
        class: "content-row"
      }, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [item?.image && item.image != '' ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: item.image,
        alt: ""
      }, null, 8, _hoisted_44)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_45, _toDisplayString(item.name), 1)]), item?.relations && item.relations > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(_component_app_icon, {
        icon: "relations"
      }), _createTextVNode(" " + _toDisplayString(item.relations), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(item.asin) + " - " + _toDisplayString(item.sku), 1)]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createVNode(_component_app_icon, {
        icon: "inactive"
      }), _createTextVNode(" Inactive ")])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createVNode(_component_app_icon, {
        icon: "rocket"
      }), _createTextVNode(" Boosted ")])])]);
    }), 128))])])])) : _createCommentVNode("", true), $options.filteredProducts.inactive.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_53, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredProducts.inactive, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.asin,
        class: "content-row"
      }, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [item?.image && item.image != '' ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: item.image,
        alt: ""
      }, null, 8, _hoisted_56)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_57, _toDisplayString(item.name), 1)]), item?.relations && item.relations > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createVNode(_component_app_icon, {
        icon: "relations"
      }), _createTextVNode(" " + _toDisplayString(item.relations), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, _toDisplayString(item.asin) + " - " + _toDisplayString(item.sku), 1)]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createVNode(_component_app_icon, {
        icon: "inactive"
      }), _createTextVNode(" Inactive ")])]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", {
        class: "boost-button",
        onClick: $event => $options.onBoosted(item)
      }, [_createVNode(_component_app_icon, {
        icon: "rocket",
        color: "#2172E1"
      }), $data.loadingAsin == item.asin ? (_openBlock(), _createBlock(_component_app_loader, {
        key: 0,
        size: 18
      })) : (_openBlock(), _createElementBlock("div", _hoisted_65, "Boost"))], 8, _hoisted_64)])]);
    }), 128))], 512)) : _createCommentVNode("", true)], 544)])])])]),
    _: 1
  });
}